import { Extension } from "@tiptap/core";

export default Extension.create({
  name: "float",
  addOptions() {
    return {
      types: ["image"],
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          float: {
            default: "default",
            parseHTML: (element) => {
              const float = element.style.float;
              if (!["left", "right"].includes(float)) {
                return { float: "default" };
              }
              return { float };
            },
            renderHTML: (attributes) => {
              // 버그 수정
              if (attributes.float.float) {
                if (attributes.float.float === "default") return {
                  style: "max-width:100%!important;margin: 0 auto;"
                };
                //return { class: `float-${attributes.float}` };
                return { style: `margin: 0px 10px 0px 10px !important;float: ${attributes.float.float};` };
              } else {
                if (attributes.float === "default") return {
                  style: "max-width:100%!important;margin: 0 auto;"
                };
                if (attributes.float === "left") return {
                  style: `margin: 0px 10px 0px 0px !important;float: ${attributes.float};`
                };
                if (attributes.float === "right") return {
                  style: `margin: 0px 0px 0px 10px !important;float: ${attributes.float};`
                };
                return { style: `margin: 0px 10px 0px 10px !important;float: ${attributes.float};` };
                //return { class: `float-${attributes.float}` };
              }
            },
          },
        },
      },
    ];
  },
});